module.exports = __webpack_public_path__ + "img/headshot-wren-rudolph.4458801d.jpg";